import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'blog-overlay',
  templateUrl: './blog-overlay.component.html',
  styleUrls: ['./blog-overlay.component.css']
})
export class BlogOverlayComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
